import React, { useEffect } from 'react';
import { Header } from '../../common_v2/components/Header';
import { useAuthentication } from '../../Login/hooks/useAuthentication';
import { Footer } from '../../common_v2/components/Footer';
import '../scss/_thankYou.scss';
import { Button, ButtonTheme } from '@apply/components';
import { useNavigate } from 'react-router-dom';
import { useWaitOverlayStore } from '@apply/components';

export const ThankYou: React.FC = () => {
    useEffect(() => {
        useWaitOverlayStore.getState().setWaiting(false);
    }, []);
    const { isRegisteredUser, authentication, isAuthenticated } = useAuthentication();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated || !isRegisteredUser) {
            window.location.href = '/login';
            return;
        }
    }, [authentication, isAuthenticated, isRegisteredUser]);

    const onCreateNewApplicationClick = () => {
        navigate('/borrower');
    };

    const onReturnHomeClick = () => {
        navigate('/home');
    };

    return (
        <>
            <div className='app-container'>
                <Header indicateDefaultMenuItem={false} />
                <div className='thankYou'>
                    <h2>Thank you.</h2>
                    <br />
                    <h4>Your application has been submitted successfully.</h4>
                    <div className='thankYou-actions'>
                        <div className='create-new-application'>
                            <Button
                                id='createNewApplicationButton'
                                theme={ButtonTheme.Tertiary}
                                width='200px'
                                height='60px'
                                handleClick={onCreateNewApplicationClick}
                            >
                                Add another application
                            </Button>
                        </div>
                        <div className='return-to-home-screen'>
                            <Button
                                id='returnHomeButton'
                                theme={ButtonTheme.Tertiary}
                                width='200px'
                                height='60px'
                                handleClick={onReturnHomeClick}
                            >
                                Done
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
